import React from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
  moduloRequerido: 'agro' | 'pesca' | 'admin';
}

const ModuleRoute = ({ children, moduloRequerido }: Props) => {
  const token = localStorage.getItem("inteagro_token");
  const modulo = localStorage.getItem("modulo");

  if (!token) return <Navigate to="/" />;

  // admin acessa tudo
  if (modulo === 'admin') return <>{children}</>;

  if (modulo !== moduloRequerido) {
    // redireciona para o módulo correto
    if (modulo === 'pesca') return <Navigate to="/admin/dashboard" />;
    return <Navigate to="/agro/dashboard" />;
  }

  return <>{children}</>;
};

export default ModuleRoute;